import type { DynamicLink } from "@jti/fe-common";

// replace format @@placeholder@@ with link
export const replacePlaceholdersWithLinks = (text: string, dynamicLinks: DynamicLink[]): string => {
  return dynamicLinks.reduce((acc, { placeholder, linkDestination, linkDisplayValue }) => {
    return acc.replaceAll(
      `@@${placeholder}@@`,
      `<a href="${linkDestination}" target="_blank" rel="noopener">${linkDisplayValue}</a>`
    );
  }, text);
};

export const replaceOneTrustPlaceholdersWithLinks = (text: string, links: DynamicLink[]): string => {
  return replacePlaceholdersWithLinks(text, links || []);
};
